<div class="PGLanguageSelector" ngbDropdown [autoClose]="true" (openChange)="openChange.emit($event)">
    <button type="button" class="btn btn-white" ngbDropdownToggle
        [attr.aria-label]="'pg-language-selector.a11y.open' | locTranslate"
        [attr.aria-haspopup]="true">
        <i class="fa-regular fa-globe fa-lg" aria-hidden="true"></i>
    </button>
    <div ngbDropdownMenu role="menu" [attr.aria-label]="'pg-language-selector.a11y.menu' | locTranslate">
        @for (language of availableLanguages; track language) {
            <button type="button" role="menuitem" class="PGLanguageSelector-Item dropdown-item {{currentLanguage == language ? 'active' : ''}}"
                [attr.aria-current]="currentLanguage == language ? 'true' : null"
                (click)="setLanguage(language)">
                <span>{{getLanguageLabel(language)}}</span>
            </button>
        }
    </div>
</div>
